import React from "react";
import HoloCard from "./HoloCard";
import { useRef, useEffect } from "react";
import { Hand } from "lucide-react";

export default function AnnouncementModal({ open, acknowledge, title, message, image, image2, imageStyle,showCard = false }) {
  const sceneRef = useRef(null);
  const cardRef = useRef(null);
  const autoTiltRef = useRef(null);
  const isInteractingRef = useRef(false);

  useEffect(() => {
    if (!open) return; // ← guard INSIDE effect

    const animate = () => {
      if (isInteractingRef.current) {
        autoTiltRef.current = requestAnimationFrame(animate);
        return;
      }

      const card = cardRef.current;
      if (!card) return;

      const SPEED = 0.0015;
      const t = performance.now() * SPEED;

      const px = 50 + Math.sin(t) * 25;
      const py = 50 + Math.cos(t * 0.8) * 20;

      const rotateX = (py - 50) / 1.6;
      const rotateY = (px - 50) / -1.6;

      card.style.setProperty("--mx", `${px}%`);
      card.style.setProperty("--my", `${py}%`);
      card.style.setProperty("--posx", `${px}%`);
      card.style.setProperty("--posy", `${py}%`);

      card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

      autoTiltRef.current = requestAnimationFrame(animate);
    };

    autoTiltRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(autoTiltRef.current);
  }, [open]); // ← depend on open

  const handleMouseMove = (e) => {
    isInteractingRef.current = true;

    const scene = sceneRef.current;
    const card = cardRef.current;
    if (!scene || !card) return;

    const rect = scene.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const px = (x / rect.width) * 100;
    const py = (y / rect.height) * 100;

    const rotateX = (py - 50) / 2;
    const rotateY = (px - 50) / -2;

    card.style.setProperty("--mx", `${px}%`);
    card.style.setProperty("--my", `${py}%`);
    card.style.setProperty("--posx", `${px}%`);
    card.style.setProperty("--posy", `${py}%`);
    card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  };

  const handleMouseLeave = () => {
    isInteractingRef.current = false;
  };

  // ✅ Now we early return AFTER hooks
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={acknowledge} style={{ zIndex: "1000" }}>
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px",
          borderRadius: "12px",
          margin: "0px",
        }}>
        {image && (
          <img
            src={image}
            alt={title}
            style={{
              width: "100%",
              borderRadius: "8px",
              marginBottom: "20px",
              ...imageStyle,
            }}
          />
        )}
        {/* {image2 && (
          <img
            src={image2}
            alt={title}
            style={{
              width: "190px",
              borderRadius: "0px",
              marginBottom: "20px",
              ...imageStyle,
            }}
          />
        )} */}
        {showCard && (
        <div
          ref={sceneRef}
          className="scene"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          style={{
            perspective: "1000px",
            width: "auto",
            aspectRatio: "320 / 380",
          }}>
          <h3 style={{ margin: "0", color: "white", opacity: "0.8", display: "flex", alignItems: "center", gap: "10px", fontSize: "16px", textAlign: "center" }}>
            <Hand size={16} /> Try moving or hover the card around
          </h3>
          <HoloCard
            image={`/players/g2_caps_fs.png`}
            foil={`/players/g2_caps_fs_foil.png`}
            mask={`/players/g2_caps_fs_mask.png`}
            topLayer={``}
            rarity={"legendary"}
            width={190}
            ref={cardRef}
            height={306}
            borderRadius="0px"
          />
        </div>
        )}
        {title && (
          <h2
            style={{
              color: "#ff5701",
              margin: "20px 0 15px 0",
              textAlign: "center",
              fontSize: "24px",
              letterSpacing: "-1px",
              fontStyle: "italic",
            }}>
            {title}
          </h2>
        )}
        {message && (
          <p
            style={{
              fontWeight: "600",
              textAlign: "center",
              margin: "0 0 20px 0",
            }}>
            {message}
          </p>
        )}

        <button
          onClick={acknowledge}
          style={{
            marginTop: "10px",
            padding: "10px 20px",
            background: "#ffd700",
            border: "none",
            borderRadius: "8px",
            fontWeight: "700",
            cursor: "pointer",
          }}>
          Got it
        </button>
      </div>
    </div>
  );
}
